import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'


const signWithGoogle = async()=>{
    try{
        const userCredential = await firebase.auth().signInWithPopup(new firebase.auth.GoogleAuthProvider())
        if(userCredential)
        {
            const {email,uid,displayName}  =userCredential.user

            return {uid,displayName, email}
        }
        else{
            alert("Something went wrong")
        }        
    }
    catch(error)
    {
        console.log('Error in Sign-In with Google:', error.message);
    }
}

export {signWithGoogle}